module.exports = __webpack_public_path__ + "static/img/kjdy7.d9364e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newestqianniu/kjdy7.png
// module id = 342
// module chunks = 0